import { orderBy } from 'lodash-es'

import { useQuery } from '@fv/client-core'
import type { FullShipment } from '@fv/client-types'

import { useSetLoadQueryData } from '@/hooks/shipments/useLoad'
import { shipperFetch } from '@/utils/shipperFetch'

import type { LoadUpload } from './types'

export const loadUploadKeys = {
  all: ['shipment-uploads'] as const,
  list: () => [...loadUploadKeys.all, 'list'] as const,
  loads: () => [...loadUploadKeys.all, 'loads-for-upload'],
  byUpload: (uploadId: string) =>
    [...loadUploadKeys.loads(), uploadId] as const,
}

export function useLoadUploads(enabled = true) {
  return useQuery(
    loadUploadKeys.list(),
    () => shipperFetch<LoadUpload[]>('/shipments/upload'),
    { enabled },
  )
}

export function useLoadsForUpload(uploadId: string) {
  const setLoadQueryData = useSetLoadQueryData()
  const query = useQuery(
    loadUploadKeys.byUpload(uploadId),
    async () => {
      const loads = await shipperFetch<FullShipment[]>(
        `/shipments/upload/${uploadId}/shipments`,
      )
      // purposely putting this in the query fetch itself and not in a hook
      // to avoid race condition with useLoad hook
      loads.forEach(load => {
        setLoadQueryData(load.loadId, load)
      })
      return orderBy(loads, 'loadId', 'asc')
    },
    { enabled: !!uploadId },
  )

  return query
}
